import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import { EmployeesLandingPres } from '../presentational';
import { addToHistory } from 'src/utils/utilsActions';
import {
  getUserRolesSelector,
  getUserInfoSelector,
  isEYProSelector,
  isCorpClientSelector,
  isEYAdminSelector,
  isEyEngagementAdminSelector,
  isCorporateClientLineManagerSelector,
  isApplicantSelector,
} from 'src/ui/features/Login/state/loginReselect';
import { PageTitle } from 'src/ui/library/PageTitle';

class EmployeesLandingContainer extends Component {
  componentDidMount() {
    const { addToHistory } = this.props;
    addToHistory(window.location.pathname);
  }

  render() {
    return (
      <React.Fragment>
        <div>
          <PageTitle title={intl.get('employees.landing.pageTitle')} />
          <EmployeesLandingPres {...this.props} />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    userInfo: getUserInfoSelector(state),
    userRoles: getUserRolesSelector(state),
    userId: state.dashboard.userId,
    isEYPro: isEYProSelector(state),
    isEYAdmin: isEYAdminSelector(state),
    isCorpClient: isCorpClientSelector(state),
    isCorpClientLineManager: isCorporateClientLineManagerSelector(state),
    isEyEngagementAdmin: isEyEngagementAdminSelector(state),
    isApplicant: isApplicantSelector(state),
  };
};

const mapDispatchToProps = {
  addToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesLandingContainer);
